import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { SignInProvider } from './SignIn';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <SignInProvider>
        <App />
      </SignInProvider>
    </BrowserRouter>
  </React.StrictMode>
);

requestAnimationFrame(() => document.body.classList.add('loaded'));
